/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeTransactionEventError
 */
export interface RuntimeTransactionEventError {
    /**
     * 
     * @type {number}
     * @memberof RuntimeTransactionEventError
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeTransactionEventError
     */
    module: string;
}

export function RuntimeTransactionEventErrorFromJSON(json: any): RuntimeTransactionEventError {
    return RuntimeTransactionEventErrorFromJSONTyped(json, false);
}

export function RuntimeTransactionEventErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeTransactionEventError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'module': json['module'],
    };
}

export function RuntimeTransactionEventErrorToJSON(value?: RuntimeTransactionEventError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'module': value.module,
    };
}


